"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.SEND_EMAIL_PANEL_INDEX = exports.MetricsTypes = exports.CREATE_EMAIL_CONTENT_INDEX = exports.CHOOSE_RECIPIENTS_PANEL_INDEX = exports.CHOOSE_EMAIL_TYPE_INDEX = void 0;
var MetricsTypes;
exports.MetricsTypes = MetricsTypes;

(function (MetricsTypes) {
  MetricsTypes["opened"] = "opened";
  MetricsTypes["clicked"] = "clicked";
  MetricsTypes["unsubscribed"] = "unsubscribed";
  MetricsTypes["complaint"] = "complaint";
  MetricsTypes["sent"] = "sent";
  MetricsTypes["delivered"] = "delivered";
})(MetricsTypes || (exports.MetricsTypes = MetricsTypes = {}));

var CHOOSE_EMAIL_TYPE_INDEX = 0;
exports.CHOOSE_EMAIL_TYPE_INDEX = CHOOSE_EMAIL_TYPE_INDEX;
var CREATE_EMAIL_CONTENT_INDEX = 1;
exports.CREATE_EMAIL_CONTENT_INDEX = CREATE_EMAIL_CONTENT_INDEX;
var CHOOSE_RECIPIENTS_PANEL_INDEX = 2;
exports.CHOOSE_RECIPIENTS_PANEL_INDEX = CHOOSE_RECIPIENTS_PANEL_INDEX;
var SEND_EMAIL_PANEL_INDEX = 3;
exports.SEND_EMAIL_PANEL_INDEX = SEND_EMAIL_PANEL_INDEX;